import apiClient, { ApiResponse } from './client';
import type {
  LangfuseDataset,
  LangfuseDatasetDetail,
  LangfuseDatasetItem,
  DatasetItemUpdateRequest,
  PersonaGenerateRequest,
  PersonaGenerateResponse,
} from '@/types/evaluator';

class EvaluatorService {
  async listDatasets(organizationId: string): Promise<ApiResponse<{ datasets: LangfuseDataset[]; total: number }>> {
    return apiClient.get('/api/evals/langfuse/datasets', { organization_id: organizationId });
  }

  async getDatasetDetail(name: string, organizationId: string): Promise<ApiResponse<LangfuseDatasetDetail>> {
    return apiClient.get(`/api/evals/langfuse/datasets/${encodeURIComponent(name)}`, { organization_id: organizationId });
  }

  async getDatasetItem(datasetName: string, itemId: string, organizationId: string): Promise<ApiResponse<LangfuseDatasetItem>> {
    return apiClient.get(
      `/api/evals/langfuse/datasets/${encodeURIComponent(datasetName)}/items/${encodeURIComponent(itemId)}`,
      { organization_id: organizationId },
    );
  }

  async updateDatasetItem(
    datasetName: string,
    itemId: string,
    organizationId: string,
    data: DatasetItemUpdateRequest,
  ): Promise<ApiResponse<LangfuseDatasetItem>> {
    return apiClient.patch(
      `/api/evals/langfuse/datasets/${encodeURIComponent(datasetName)}/items/${encodeURIComponent(itemId)}?organization_id=${encodeURIComponent(organizationId)}`,
      data,
    );
  }

  async deleteDatasetItem(
    datasetName: string,
    itemId: string,
    organizationId: string,
  ): Promise<ApiResponse<{ success: boolean; message: string; items_deleted: number }>> {
    return apiClient.delete(
      `/api/evals/langfuse/datasets/${encodeURIComponent(datasetName)}/items/${encodeURIComponent(itemId)}`,
      { organization_id: organizationId },
    );
  }

  async deleteDataset(
    name: string,
    organizationId: string,
  ): Promise<ApiResponse<{ success: boolean; message: string; items_deleted: number }>> {
    return apiClient.delete(
      `/api/evals/langfuse/datasets/${encodeURIComponent(name)}`,
      { organization_id: organizationId },
    );
  }

  async generatePersonas(data: PersonaGenerateRequest): Promise<ApiResponse<PersonaGenerateResponse>> {
    return apiClient.post('/api/evals/datasets/generate', data);
  }
}

const evaluatorService = new EvaluatorService();
export default evaluatorService;
